// Telemetry tab — A01 pivot placeholder. Pre-pivot mission_telemetry_snapshot
// retired. Workspace telemetry lands with working-agent turn tracking (A03).

import { TabScrollbox } from "../../chrome/TabScrollbox";

interface Props {
  workspaceId: number;
}

export function TelemetryTab(_props: Props) {
  return (
    <TabScrollbox>
      <div className="px-6 py-10 text-sm text-muted">
        <p className="mb-3 text-primary">Telemetry — pending redesign</p>
        <p>
          Per-turn cost + duration snapshots land with the working-agent
          loop (A03). Until then the Usage tab carries org-level rollups.
        </p>
      </div>
    </TabScrollbox>
  );
}
